import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';
import { computed } from 'vue';
import { message } from 'ant-design-vue';

// 供应商
export const useSuppliersStore = defineStore({
  id: 'suppliers',
  state: () => ({
    suppliers: [],
    loading: false,
    modalVisible: false,
    modalTitle: '',
    searchState: {
      pageNum: 1,
      pageSize: 10,
      supplier_name: '',
      email: '',
      status: 'enabled'
    },
    modalState: {
      visible: false,
      title: 'Title'
    },
    formState: {
      id: '',
      supplier_name: '',
      email: '',
      secondary_email: '',
      comment: ''
    },
    pagination: {}
  }),

  getters: {
    computedPagination() {
      return computed(() => ({
        total: this.searchState.total,
        current: this.searchState.pageNum,
        pageSize: this.searchState.pageSize,
        defaultPageSize: 10,
        showTotal: total => `总共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true
      })).value;
    }
  },

  actions: {
    async fetchAll() {
      this.loading = true;
      await fetchWrapper.post(process.env.VUE_APP_API_URL + `/api/supplier`, this.searchState)
      .then(
        response => response
      )
      .then(data => {
        if (data.code === 520) {
          this.suppliers = data.message.data;
          this.searchState = { ...this.searchState, total: data.message.total };
          this.pagination = this.computedPagination;
        } else {
          message.error(data.message);
        }
      })
      .catch(error => console.log(error));
      this.loading = false;
    },
    async update(values) {
      await fetchWrapper.post(process.env.VUE_APP_API_URL + `/api/updateSupplier`, values)
      .then(
        response => response
      )
      .then(data => {
        if (data.code === 520) {
          message.success('更新成功');
          this.modalVisible = false;
          this.fetchAll();
        } else {
          message.error(data.message);
        }
      })
      .catch(error => console.log(error));
      this.loading = false;
    },
    async changeStatus(record) {
      await fetchWrapper.post(process.env.VUE_APP_API_URL + `/api/changeStatusSupplier`, record)
      .then(
        response => response
      )
      .then(data => {
        if (data.code === 520) {
          message.success('更新成功');
          record.status = record.status == 'enabled' ? 'disabled' : 'enabled';
          this.suppliers.splice(index, 1, record);
        } else {
          message.error(data.message);
        }
      })
      .catch(error => console.log(error));
    },
  }
});